<template>
  <Dialog v-model:visible="visible"
    :modal="true"
    position="center"
    :contentStyle="{'overflow': 'scroll'}"
    ref="dialog" @show="onDialogShow"
    :style="{ maxHeight: '90vh' }"
    >
    <template #header>
      <h2>Импортиране на продукти</h2>
    </template>
    <div class="border-layout" style="width: 1200px">
      <div class="north">
        <div class="p-fluid p-grid">
          <div class="p-field p-col-12 p-md-4">
            <label for="category">CSV Файл</label>
            <input type="file" ref="file" name="files" @change="fileHandler"/>
          </div>
          <div class="p-field p-col-12 p-md-4" v-if="importedData.header.length > 0">
            <label for="category">Продуктова група</label>
            <AutoComplete v-model="category" :dropdown="true" field="name"
              :suggestions="categories" @complete="searchCategory($event)" placeholder="Въведете група"/>
          </div>
          <div class="p-field p-col-12 p-md-4" v-if="importedData.header.length > 0">
            <label for="selected">Идентификатор</label>
            <Dropdown v-model="productKey" :options="importedData.header" optionLabel="value" optionValue="key"
              placeholder="Колона, съдържаща продуктов номер"/>
          </div>
          <div class="p-field p-col-12 p-md-6" v-if="importedData.header.length > 0">
            <label for="selected">Име на продукт</label>
            <MultiSelect  v-model="productName" :options="importedData.header"
              placeholder="Колони, формиращи името на продукт" optionLabel="value" optionValue="key"/>
          </div>
          <div class="p-field p-col-12 p-md-3" v-if="importedData.header.length > 0">
            <label for="category">Начин на актуализиране</label>
            <ToggleButton v-model="fullUpdate"
                onLabel="Пълно"
                offLabel="Частично"
                onIcon="pi pi-check" offIcon="pi pi-times"/>
          </div>
          <div class="p-field p-col-12 p-md-3" v-if="importedData.header.length > 0">
            <label for="selected">Цена на едро (без ДДС)</label>
            <Dropdown v-model="priceWholesale" :options="importedData.header" optionLabel="value" optionValue="key"/>
          </div>
          <div class="p-field p-col-12 p-md-6" v-if="importedData.header.length > 0">
            <label for="selected">Други данни</label>
            <MultiSelect v-model="otherData" :options="importedData.header" optionLabel="value" optionValue="key"/>
          </div>
          <div class="p-field p-col-12 p-md-3" v-if="importedData.header.length > 0">
            <label for="selected">Импорт само при стойност</label>
            <Dropdown v-model="onlyIfValue" :options="importedData.header" optionLabel="value" optionValue="key"/>
          </div>
          <div class="p-field p-col-12 p-md-3" v-if="importedData.header.length > 0">
            <label for="selected">Цена на дребно (с ДДС)</label>
            <Dropdown v-model="priceRetail" :options="importedData.header" optionLabel="value" optionValue="key"/>
          </div>
        </div>
      </div>
      <div class="import" v-if="importedData.header.length > 0">
        <h3>Импортирани данни</h3>
        <DataTable :value="importedData.lines"
          :rowHover="true"
          :scrollable="true"
          scrollHeight="flex"
          style="height: calc(100vh - 410px)"
          class="p-datatable-gridlines p-datatable-striped p-datatable-sm center">
          <Column header="Код" style="flex: 0 0 7em">
            <template #body="props">
              {{itemNumber(props.data)}}
            </template>
          </Column>
          <Column header="Наименование" style="flex-grow: 4000">
            <template #body="props">
              {{itemName(props.data)}}&nbsp;
            </template>
          </Column>
          <Column header="Цена на едро (без ДДС)" style="flex: 0 0 7em" bodyClass="right">
            <template #body="props">
              {{itemPriceWholesale(props.data)}}
            </template>
          </Column>
          <Column header="Цена на дребно (с ДДС)" style="flex: 0 0 7em" bodyClass="right">
            <template #body="props">
              {{itemPriceRetail(props.data)}}
            </template>
          </Column>
          <Column header="Други данни" style="flex: 0 0 25em">
            <template #body="props">
              <ul>
                <li v-for="(value, key) in itemData(props.data)" :key="key">
                  {{key}}: {{value}}
                </li>
              </ul>
            </template>
          </Column>
          <Column header="Импорт" style="flex: 0 0 5em" bodyClass="center">
            <template #body="props">
              <div v-if="shouldAccept(props.data)" class="pi pi-check"></div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>

    <template #footer>
      <ButtonsApplyCancel @apply="onImport" @cancel="$refs.dialog.close()" label-ok="Запис"/>
    </template>
  </Dialog>

</template>

<script>
export default {
  inheritAttrs: false,
  emits: {
    close: null
  },
  data() {
    return {
      visible: false,
      category: null,
      productKey: null,
      productName: [],
      priceWholesale: null,
      priceRetail: null,
      otherData: [],
      onlyIfValue: null,
      fullUpdate: false,
      importedData: {
        header: [],
        lines: [],
        accepted: []
      },
      textResult: "",
      categories: [],
      files: [],
      data: {}
    }
  },

  created() {
  },

  props: {
    title: String,
    selected: Object
  },

  methods: {
    onDialogShow() {
      this.category = null;
      this.productKey = null;
      this.productName = [];
      this.priceWholesale = null;
      this.priceRetail = null;
      this.otherData = [];
      this.importedData = {
        header: [],
        lines: []
      };
    },
    shouldAccept(line) {
      if (this.itemPriceWholesale(line) == null || this.itemPriceRetail(line) ==  null) {
        return false;
      }
      return this.itemNumber(line) &&  this.itemCondition(line)
    },
    searchCategory(event) {
      var ctx = this;
      this.$http.get('/product-category', {
        params: {
          query: event.query
        }
      }).then(res => ctx.categories = res.data)
    },

    loadCsvFile(fileToRead) {
      var ctx = this;
      var reader = new FileReader();
      // Handle errors load
      var processData = function(csv) {
        ctx.importedData = {
          header: [],
          lines: []
        }
        var lines = csv.split(/\r\n|\n/);
        for (var line of lines) {
          ctx.importedData.lines.push(line.split(";"))
        }
        if (ctx.importedData.lines.length > 0) {
          ctx.importedData.header = ctx.importedData.lines[0]
          var header = [];
          for (var i = 0; i < ctx.importedData.header.length; i++) {
            header.push({
              key: i,
              value: ctx.importedData.header[i]// + ' (' + (i + 1) + ')'
            });
          }
          ctx.importedData.header = header;
          ctx.importedData.lines.shift();
        }
      };
      reader.onload = function(event) {
        var csv = event.target.result;
        processData(csv);
      };
      reader.onerror = function(evt) {
        if(evt.target.error.name == "NotReadableError") {
          alert("Canno't read file !");
        }
      }
      // Read file into memory as UTF-8
      reader.readAsText(fileToRead);
    },
    fileHandler() {
      var file = this.$refs.file.files[0];
      // Check for the various File API support.
      if (window.FileReader) {
          // FileReader are supported.
          this.loadCsvFile(file);
      } else {
          alert('FileReader is not supported in this browser.');
      }
    },
    onImport() {
      if(this.category == null) {
        alert("Не е посочена продуктова категория")
      }
      var products = [];
      for (var line of this.importedData.lines) {
        if (this.shouldAccept(line)) {
          var item = {
            number: this.itemNumber(line),
            name: this.itemName(line),
            priceWholesale: this.itemPriceWholesale(line),
            priceRetail: this.itemPriceRetail(line),
            properties: this.itemData(line)
          }
          if (isNaN(item.priceWholesale) || isNaN(item.priceRetail)) {
            continue;
          }
          if(item.number && item.name) {
            products.push(item);
          } else {
            console.log("Item", item, " not added")
          }
        }
      }
      console.log(products)
      var data = {
        category: this.category.id,
        products: products
      }
      var ctx = this;
      var event = {
        onSuccess () {
          ctx.$toast.add({
            severity: "info", summary: "Успешна обработка",
            detail: "Данните бяха успешно обработени от сървъра.", life: 3300
          });
          ctx.visible = false;
          ctx.$emit('close')
        },
        onFailure (message) {
          var error = "Грешка: " + message.response.data;
          ctx.$toast.add({severity: "error", summary: "Грешка при импорт на продукти", detail: error, life: 5300});
        }
      }
      this.$http.post("/product/import", data)
            .then(event.onSuccess)
            .catch(event.onFailure);
    },
    trimString(s, r, repl) {
      if (s) {
        s = s.trim();
        if (r != undefined && repl != undefined) {
          s = s.replace(r, repl);
        }
        return s;
      }
      return "";
    },
    open() {
      this.visible = true;
    },
    itemNumber(item) {
      if (Number.isInteger(this.productKey)) {
        return this.trimString(item[Number(this.productKey)])
      }
      return null;
    },
    itemCondition(item) {
      if (Number.isInteger(this.onlyIfValue)) {
        return this.trimString(item[Number(this.onlyIfValue)]).length > 0
      }
      return true;
    },
    itemName(item) {
      var s = "";
      for(var key of this.productName) {
        if (Number.isInteger(key)) {
          if (s.length > 0) {
            s += ' ';
          }
          s += item[Number(key)]
        }
      }
      return this.trimString(s);
    },
    itemPriceWholesale(item) {
      if (Number.isInteger(this.priceWholesale)) {
        return this.trimString(item[Number(this.priceWholesale)], ",", ".")
      }
      return null;
    },
    itemPriceRetail(item) {
      if (Number.isInteger(this.priceRetail)) {
        return this.trimString(item[Number(this.priceRetail)], ",", ".")
      }
      return null;
    },
    itemData(item) {
      var data = {};
      try  {
        for(var key of this.otherData) {
          if (Number.isInteger(key)) {
            data[this.trimString(this.importedData.header[Number(key)].value)] = this.trimString(item[Number(key)]);
          }
        }
      } catch(e) {
        console.log(e)
      }
      return data;
    }
  },

  computed: {
    imported: {
      get() {
        return this.lines;
      },
      set(newValue) {
        this.lines = newValue;
      }
    }
  }
}
</script>

<style>
    .import .p-datatable-scrollable-body {
      max-height: 80px !important;
    }
</style>
